import React, { createContext, useState, useContext, useEffect } from 'react';
import { api } from '../utils/api';
import { useAuth } from './AuthContext';

const ValuesContext = createContext();

export const ValuesProvider = ({ children }) => {
  const [selectedValues, setSelectedValues] = useState([]);
  const [loading, setLoading] = useState(true);
  const { currentUser } = useAuth();

  // Load values from backend when user changes (login/logout)
  useEffect(() => {
    const loadValues = async () => {
      // Check if user is authenticated
      const authToken = localStorage.getItem('token');
      
      if (!authToken || !currentUser) {
        setSelectedValues([]);
        setLoading(false);
        return;
      }

      try {
        const response = await api.values.get();
        setSelectedValues(response.data?.values || []);
      } catch (error) {
        console.error('Error loading values:', error);
        setSelectedValues([]);
      } finally {
        setLoading(false);
      }
    };

    loadValues();
  }, [currentUser]); // Re-run when currentUser changes (login/logout)

  // Save to backend
  const updateSelectedValues = async (values) => {
    setSelectedValues(values);
    
    // Check if user is authenticated
    const authToken = localStorage.getItem('token');
    if (!authToken) {
      console.warn('Not authenticated, values not saved');
      return;
    }

    try {
      await api.values.update(values);
    } catch (error) {
      console.error('Error saving selected values:', error);
    }
  };

  return (
    <ValuesContext.Provider value={{ selectedValues, updateSelectedValues, loading }}>
      {children}
    </ValuesContext.Provider>
  );
};

export const useValues = () => {
  const context = useContext(ValuesContext);
  if (!context) {
    throw new Error('useValues must be used within a ValuesProvider');
  }
  return context;
};
